<template>
  <div class="container mobile-logo">
    <div class="row">
      <div class="col-md-12">
        <img class="mb-4" src="../../assets/logo.png" alt="Logo" width="200" height="110">
      </div>
    </div>
  </div>
  <div class="container-fluid checkout-mobile">
    <div class="container">
      <div class="row checkout">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <table>
            <tr>
              <td class="cart-ico">
                <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"></path>
                </svg>
              </td>
              <td v-on:click="mobileSummary">
                <span v-if="!mobileSummaryActive">Show order summary
                  <svg width="11" height="6" xmlns="http://www.w3.org/2000/svg" class="dropdown-mobile"
                       fill="#000">
                    <path
                        d="M.504 1.813l4.358 3.845.496.438.496-.438 4.642-4.096L9.504.438 4.862 4.534h.992L1.496.69.504 1.812z"></path>
                  </svg>
                </span>
                <span v-if="mobileSummaryActive">
                  Hide order summary
               <svg width="11" height="7" xmlns="http://www.w3.org/2000/svg" class="dropdown-mobile"
                    fill="#000"><path
                   d="M6.138.876L5.642.438l-.496.438L.504 4.972l.992 1.124L6.138 2l-.496.436 3.862 3.408.992-1.122L6.138.876z"></path></svg>
                </span>
              </td>
              <td class="price">
                <span class="">{{ this.products[0].sign.prefix }}</span>
                {{ subTotal + shipping.price }}
                <span class="">{{ this.products[0].sign.suffix }}</span>
              </td>
            </tr>
          </table>
          <transition name="fade">
            <div v-if="mobileSummaryActive">
              <table class="checkout-products">
                <tr v-for="item in this.products">
                  <td class="thumbnail"><img :src="item.image"/></td>
                  <td class="product-name">{{ item.name }}</td>
                  <td class="price">
                    <span v-if="item.originalPrice != item.price" class="discounted-price">{{
                        item.sign.prefix
                      }}{{ item.originalPrice }}{{ item.sign.suffix }}<br/></span>
                    <span>{{ item.sign.prefix }}{{ item.price }}{{ item.sign.suffix }}</span>
                  </td>
                </tr>
              </table>

              <table class="checkout-summary">
                <tr class="margin-top">
                  <td class="name">Subtotal</td>
                  <td class="price" style="color: #323232;">
                    <span class="currency">{{ this.products[0].sign.prefix }}</span>
                    {{ subTotal }}
                    <span class="currency">{{ this.products[0].sign.suffix }}</span>
                  </td>
                </tr>
                <tr class="margin-bottom">
                  <td class="name">Shipping</td>
                  <td class="price">
                    <span class="currency">{{ this.products[0].sign.prefix }}</span>
                    {{ this.shipping.price }}
                    <span class="currency">{{ this.products[0].sign.suffix }}</span>
                  </td>
                </tr>
                <tr class="margin-top total">
                  <td class="name">Total</td>
                  <td class="price">
                    <span class="currency">{{ this.products[0].sign.prefix }}</span>
                    {{ Number(subTotal + this.shipping.price).toFixed(2) }}
                    <span class="currency">{{ this.products[0].sign.suffix }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row checkout">
      <div class="col-lg-7 col-md-12 col-sm-12">
        <img class="mb-4 desktop-logo" src="../../assets/logo.png" alt="Logo" width="200" height="110">
        <form id="paypalButton" method="post"></form>
        <h2 class="section-header">Contact information</h2>
        <form class="checkout-form" v-on:submit.prevent>
          <div class="input-wrapper">
            <input type="text" name="email" v-model="formData.email" placeholder="Email"/>
          </div>
          <h2 class="section-header">Shipping address</h2>
          <div class="row">
            <div class="col-lg-6">
              <div class="input-wrapper">
                <input autocapitalize="off" spellcheck="false" v-model="formData.firstName" type="text" name="firstName"
                       placeholder="First name"/>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input-wrapper">
                <input autocapitalize="off" spellcheck="false" v-model="formData.lastName" type="text" name="lastName"
                       placeholder="Last name"/>
              </div>
            </div>
          </div>
          <div class="input-wrapper">
            <input autocapitalize="off" spellcheck="false" v-model="formData.companyName" type="text" name="company"
                   placeholder="Company (optional)"/>
          </div>
          <div class="input-wrapper">
            <input autocapitalize="off" spellcheck="false" v-model="formData.address" type="text" name="address"
                   placeholder="Address"/>
          </div>
          <div class="input-wrapper">
            <input autocapitalize="off" spellcheck="false" v-model="formData.apartment" type="text" name="apartment"
                   placeholder="Apartment, suite, etc. (optional)"/>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="input-wrapper">
                <input autocapitalize="off" spellcheck="false" v-model="formData.city" type="text" name="city"
                       placeholder="City"/>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input-wrapper">
                <input autocapitalize="off" spellcheck="false" v-model="formData.postalCode" type="text"
                       name="postalCode" placeholder="Postal code"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div id="country" class="col-lg-12 col-md-12 col-sm-12">
              <div class="input-wrapper">
                <select name="country" v-model="formData.country" @change="countryChange()">
                  <option value="">Choose country</option>
                  <option v-for="(name, code) in this.countries" v-bind:value="code">{{ name }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class=" input-wrapper" v-if="this.showStatesSelector">
                <select name="state" v-model="formData.stateCode">
                  <option value="" selected>Choose state</option>
                  <option v-for="(name, code) in this.states" v-bind:value="code">{{ name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="input-wrapper">
            <input type="text" name="phone" v-model="formData.phone" placeholder="Phone"/>
          </div>
          <!-- Shipping -->
          <h2 class="section-header">Shipping Method</h2>
          <div class="content-box">

            <p v-if="formData.country == ''">Enter your shipping address to see shipping options</p>
            <div class="row" v-if="formData.country != ''">
              <div class="col-lg-1 col-md-1 col-sm-1">
                <input type="radio" checked="checked"/>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7">
                <p>{{ shipping.name }}</p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 text-right">
                <span class="currency">{{ this.products[0].sign.prefix }}</span>
                {{ shipping.price }}
                <span class="currency">{{ this.products[0].sign.suffix }}</span>
              </div>
            </div>

          </div>

          <!-- Payment -->
          <h2 class="section-header">Payment information</h2>
          <small>All transactions are secure and encrypted</small>
          <div class="content-box">
            <div class="payment-box">
              <div class="row">
                <div class="col-lg-6">
                  <strong>Credit Card</strong>
                </div>
                <div class="col-lg-6 card-list">
                  <img src="../../assets/visa.svg"/>
                  <img src="../../assets/master.svg"/>
                  <img src="../../assets/jcb.svg"/>
                  <img src="../../assets/american.svg"/>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12" id="cardErrors"></div>
              </div>
              <div class="row">
                <div class="col-lg-12" id="cardDetails"></div>
              </div>
            </div>
          </div>

          <div class="input-wrapper col-lg-4 col-sm-12 col-md-12">
            <input class="continue-button" type="submit" value="Processs order" v-on:click="processOrder"/>
          </div>
        </form>
      </div>
      <div class="col-lg-1 col-md-12 col-sm-12"></div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 checkout-right-panel">
        <table class="checkout-products">
          <tr v-for="item in this.products">
            <td class="thumbnail"><img :src="item.image"/></td>
            <td class="product-name">{{ item.name }}</td>
            <td class="price">
              <span v-if="item.originalPrice != item.price" class="discounted-price">{{
                  item.sign.prefix
                }}{{ item.originalPrice }}{{ item.sign.suffix }}<br/></span>
              <span>{{ item.sign.prefix }}{{ item.price }}{{ item.sign.suffix }}</span>
            </td>
          </tr>
        </table>
        <div class="row discount-form discount-section">
          <div class="col-lg-9">
            <input type="text" v-on:input="discountButton" name="discount" placeholder="Discount code"
                   v-model="this.formData.coupon"/>
          </div>
          <div class="col-lg-3">
            <button id="discountButton" v-on:click="applyCoupon(this.formData.coupon)" class="discount-button-disabled">
              Apply
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <span class="discount-tag" v-for="item in this.settings.appliedCoupons">
              {{ item }}
            </span>
          </div>
        </div>
        <table class="checkout-summary">
          <tr class="margin-top">
            <td class="name">Subtotal</td>
            <td class="price" style="color: #323232;">
              <span class="currency">{{ this.products[0].sign.prefix }}</span>
              {{ this.subTotal }}
              <span class="currency">{{ this.products[0].sign.suffix }}</span>
            </td>
          </tr>
          <tr class="margin-bottom">
            <td class="name">Shipping</td>
            <td class="price">
              <span class="">{{ this.products[0].sign.prefix }}</span>
              {{ this.shipping.price }}
              <span class="">{{ this.products[0].sign.suffix }}</span>
            </td>
          </tr>
          <tr class="margin-top total">
            <td class="name">Total</td>
            <td class="price">
              <span class="">{{ this.products[0].sign.prefix }}</span>
              {{ Number(Number(this.subTotal) + this.shipping.price).toFixed(2) }}
              <span class="">{{ this.products[0].sign.suffix }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {gofarService} from "../../helpers/gofar-service";
import {HTTP_METHODS} from "../../helpers/config";
import {createSubscription, productsConverter} from "../../helpers/chargebee-checkout";
import {facade, filter, InputFacade} from 'vue-input-facade';
import {COUNTRIES, DELIVERIES, STATES} from "../../helpers/data/address-data-provider";
import * as StripeAPI from 'stripe';

export default {
  name: 'CheckoutForm',
  components: {InputFacade},
  directives: {facade},
  filters: {facade: filter},
  data() {
    return {
      countries: COUNTRIES,
      states: STATES,
      showStatesSelector: false,
      mobileSummaryActive: false,
      products: {},
      subscriptions: {},
      shippingMethods: {},
      coupons: {},
      formData: {
        email: '',
        firstName: '',
        lastName: '',
        companyName: '',
        address: '',
        apartment: '',
        stateCode: '',
        postalCode: '',
        city: '',
        country: '',
        phone: '',
        discount: '',
        payment: {
          cardNumber: '',
          nameOnCard: '',
          expiryYear: '',
          expiryMonth: '',
          cvv: ''
        }
      },
      subTotal: 0.00,
      shipping: {
        name: '',
        price: 0.00
      },
      settings: {
        products: [],
        plan: '',
        coupon: '',
        currency: 'AUD',
        appliedCoupons: []
      },
      paypalExpress: {
        payment_method: {
          reference_id: '',
        }
      },
      stripeClient: null,
      stripeAPI: StripeAPI(process.env.VUE_APP_STRIPE_KEY),
      card: null
    }
  },
  mounted() {
    this.applyCoupon(this.settings.coupon);
    let paypal = document.createElement('script');
    paypal.setAttribute('src', 'https://www.paypalobjects.com/api/checkout.js');
    document.head.appendChild(paypal);

    let stripe = document.createElement('script');
    stripe.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(stripe);

    // window.paypalCheckoutReady = function () {
    //   paypal.checkout.setup(process.env.VUE_APP_PAYPAL_MERCHANT_ID, {
    //     environment: process.env.VUE_APP_PAYPAL_ENVIRONMENT,
    //     container: 'paypalButton'
    //   });
    // };
    setTimeout(() => {
      this.stripeClient = Stripe(process.env.VUE_APP_STRIPE_KEY);
      this.cardElement = this.stripeClient.elements().create('card', {
        iconStyle: 'solid',
        style: {
          base: {
            iconColor: '#c4f0ff',
            color: '#000',
            fontWeight: 500,
            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',

            ':-webkit-autofill': {
              color: '#fce883',
            },
            '::placeholder': {
              color: '#87BBFD',
            },
          },
          invalid: {
            iconColor: '#FFC7EE',
            color: '#FFC7EE',
          },
        },
      });
      this.cardElement.mount('#cardDetails');
      this.cardElement.on('change', function (event) {
        var displayError = document.getElementById('cardErrors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      })
      // registerElements([card], 'card');
    }, 2000);
  },
  async created() {
    this.settings.products = this.$route.query.products.split(',') || '';
    this.settings.plan = this.$route.query.plan || '';
    this.settings.products.push(this.settings.plan);
    this.settings.coupon = this.$route.query.coupon || '';

    await this.loadItems();

  },
  methods: {
    countryChange: function () {
      this.formData.stateCode = ''; //always clear in case of changing the country
      this.showStatesSelector = Object.keys(STATES).includes(this.formData.country);
      if (this.showStatesSelector) {
        document.getElementById('country').classList = ['col-lg-6 col-md-6 col-sm-12'];
        this.states = STATES[this.formData.country];
      } else {
        document.getElementById('country').classList = ['col-lg-12 col-md-12 col-sm-12'];
      }
      // Set shipping
      this.shipping = {
        ...(this.shippingMethods.find((method) => method.id === DELIVERIES[this.formData.country]) ||
            this.shippingMethods.find((method) => method.id === DELIVERIES.default))
      }; // Clone object for changing price purposes
      this.shipping.price = this.shipping.price / 100;
      console.log(this.products);
    },
    discountButton: function () {
      const discountButton = document.getElementById('discountButton');

      if (this.settings.coupon.length > 0) {
        discountButton.classList.remove('discount-button-disabled');
        discountButton.classList.add('discount-button-enabled');
      } else {
        discountButton.classList.remove('discount-button-enabled');
        discountButton.classList.add('discount-button-disabled');
      }
    },
    loadItems: async function () {
      const products = await gofarService('/api/checkout/products', HTTP_METHODS.GET);
      const subscriptions = await gofarService('/api/checkout/subscription-plans', HTTP_METHODS.GET);
      const shippingMethods = await gofarService('/api/checkout/shipping-methods', HTTP_METHODS.GET);
      const coupons = await gofarService('/api/checkout/coupons', HTTP_METHODS.GET);

      [this.products, this.subTotal] = productsConverter([...products.data, ...subscriptions.data], this.settings.products);
      this.shippingMethods = shippingMethods.data;
      this.coupons = coupons.data;
    },
    mobileSummary: function () {
      this.mobileSummaryActive = !this.mobileSummaryActive;
    },
    applyCoupon: function (couponCode) {
      if (couponCode.length === 0 || this.settings.appliedCoupons.includes(couponCode)) {
        return;
      }

      const coupon = this.coupons.find((coupon) => coupon.id === couponCode);
      if (!coupon) {
        return;
      }
      this.subTotal = 0.00;
      this.products = this.products.map((product) => {
        // If only for specific addons or plans then continue
        if ((coupon.addon_constraint === 'addon_constraint' && !coupon.addon_ids.includes(product.id)) ||
            (product.id === this.settings.plan && coupon.plan_constraint === 'specific' && !coupon.plan_ids.includes(product.id))) {
          console.log(`${product.id} rejected`, coupon.plan_ids);
          return product;
        }
        switch (coupon.discount_type) {
          case 'fixed_amount':
            product.price = (product.price - coupon.discount_amount) < 0 ? 0 : ((product.price - coupon.discount_amount) / 100).toFixed(2);
            break;
          case 'percentage':
            product.price = ((product.price * (100 - coupon.discount_percentage)) / 100).toFixed(2);
            break;
        }
        this.subTotal += parseFloat(product.price);
        return product;
      });
      this.settings.appliedCoupons.push(coupon.id);

      this.subTotal = this.subTotal.toFixed(2);
    },
    processPayment: async function () {
      // Step 1 - Create payment method
      const stripeResponse = await this.stripeAPI
          .paymentIntents.create({
            amount: Number(this.subTotal) + this.shipping.price,
            currency: this.products[0].currency,
            payment_method_types: ['card']
          });
      if (stripeResponse.error) {
        alert(stripeResponse.error.message);
        return;
      }
      const clientSecret = stripeResponse.client_secret;

      // Step 2 - Create payment intent
      const payment = await this.stripeClient.confirmCardPayment(clientSecret, {
        payment_method: {
          card: this.card
        }
      })
      console.log(payment);
    },
    processOrder: async function () {
      await this.processPayment();
      return;
      const nameOnCard = this.formData.payment.nameOnCard.split(' ');
      const paymentData = {
        first_name: nameOnCard[0] || '',
        last_name: nameOnCard[1] || '',
        number: this.formData.payment.cardNumber,
        expiry_month: this.formData.payment.expiryMonth,
        expiry_year: this.formData.payment.expiryYear,
        cvv: this.formData.payment.cvv
      };
      // const subscription = await createSubscription(this.formData, this.settings, [this.products, this.shipping], paymentData);
      // console.log(subscription);

    }
  }
}
</script>
